import { useLocalStorage } from 'react-use';

export function useUserDetailsStore() {
  const [currentUserDetail, setCurrentUserDetail] = useLocalStorage('currentUserDetail', false);

  return {
    currentUserDetail, setCurrentUserDetail,
  };
}
